var map = {
	"./ada.png": 14185,
	"./bib.png": 35742,
	"./btc.png": 78968,
	"./doge.png": 35826,
	"./eth.png": 81196,
	"./link.png": 37025,
	"./usdt.png": 97817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30698;